import { z } from 'zod';

import { RequestedOperationStatusV5 } from '../../../../api/generated/cz.partners.bank.backofficegateway.signs';

export const OperationStatusFormEnum = {
	ALL: 'ALL',
	WAITING_FOR_SIGN: RequestedOperationStatusV5.WAITING_FOR_SIGN,
} as const;

export type OperationStatusFormEnumKeys = keyof typeof OperationStatusFormEnum;

export const DEFAULT_OPERATION_STATUS =
	OperationStatusFormEnum.WAITING_FOR_SIGN;

export const internalControlsFilterFormSchema = z.object({
	operationStatus: z.enum(OperationStatusFormEnum),
});

export type InternalControlsFilterForm = z.infer<
	typeof internalControlsFilterFormSchema
>;
